module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_9005.9d1ec71d.png";